module.exports = __webpack_public_path__ + "static/media/StandingTall.870b4648.png";